<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" />
    <b-container fluid v-else class="m-0">
      <div>
        <Logo :logoProps="logo" />
      </div>
      <div id="exam" v-if="startExam">
        <div v-if="showTimer">
          {{ $t("certifications.timeLeft") }}
          <span style="font-size:40px;">
            <strong>{{ examPresentTime }}</strong>
          </span>
        </div>
        <b-row class="mb-4 pt-2">
          <b-col cols="3">
            <div class="mt-5">
              <div class="first" :style="bgStyles"></div>
              <div id="talkbubble" :style="[bgStyles, customTriangle]">
                <h2>
                  {{ $t("certifications.question") }}
                  {{ currentQuestionIndex + 1 }}
                </h2>
              </div>
            </div>
          </b-col>

          <b-col cols="7">
            <!-- <h3 class="text-muted">Anti bribery exam</h3> -->
            <!-- <CountDownTimer :date="'2009-12-31 23:59'"/> -->
            <b-row :dir="$store.state.rightAlign ? 'rtl' : 'ltr'">
              <b-card
                class="mb-3 mr-2"
                style="height: calc(100vh - 170px); width:100%;"
              >
                <template v-slot:header>
                  <strong class="mb-0 text-left">
                    <b-badge variant="dark"
                      >Q{{ currentQuestionIndex + 1 }}</b-badge
                    >
                    &nbsp;{{ currentQuestion }}
                  </strong>
                </template>

                <!-- for Radio type quiestions -->
                <div
                  :class="$store.state.rightAlign ? 'text-right animate-slide-from-right' : 'text-left animate-slide-from-left'"
                  v-if="currentAnswerType == 1"
                  style="overflow-y: y;height: 100%;"
                >
                  <b-form-group
                    :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                    v-for="(answer, answerIndex) in currentAnswers"
                    :key="answerIndex"
                  >
                    <b-form-radio
                      :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                      v-model="selectedRadioAns"
                      :value="answer.answer"
                      @change="
                        setAnswer($event, answerIndex, 'radio'),
                          autoNextQuestion()
                      "
                      style="font-size:14px;"
                      >{{ answer.answer[selectedLanguage] || answer.answer }}
                      </b-form-radio
                    >
                  </b-form-group>
                  <div>
                    <p class="v-html" v-if="questions && questions.length && questions[currentQuestionIndex].positiveMessage" v-html="sanitizeHtml(questions[currentQuestionIndex].positiveMessage[selectedLanguage])"></p>
                  </div>
                </div>

                <!-- for Checkboxes type quiestions -->
                <div
                  :class="$store.state.rightAlign ? 'text-right animate-slide-from-right' : 'text-left animate-slide-from-left'"
                  v-if="currentAnswerType == 2"
                  style="overflow-y:auto;height: 100%;"
                >
                  <b-form-group
                    v-for="(answer, index) in currentAnswers"
                    :key="index"
                  >
                    <b-form-checkbox
                      :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                      v-model="selectedCheckboxAns"
                      :value="answer.answer"
                      @input="setAnswer($event, index, 'checkbox')"
                      style="font-size:14px;"
                      >{{ answer.answer[selectedLanguage] || answer.answer }}
                      </b-form-checkbox
                    >
                  </b-form-group>
                </div>

                <!-- for Buttons type quiestions -->
                <b-form-group
                  class="text-left animate-slide-from-left"
                  v-if="currentAnswerType == 3"
                  style="overflow-y: y;height: 100%;"
                >
                  <b-button
                    pill
                    :variant="
                      selectedButtonAns == answer.answer
                        ? 'primary'
                        : 'outline-primary'
                    "
                    class="mr-3"
                    v-for="(answer, index) in currentAnswers"
                    :key="index"
                    @click="
                      setAnswer(answer, index, 'button'), autoNextQuestion()
                    "
                    >{{ answer.answer[selectedLanguage] || answer.answer }}</b-button
                  >
                </b-form-group>
              </b-card>
            </b-row>

            <!-- <span>Your selected answer:</span>
                        <b v-if="currentAnswerType == 1" class="text-primary">{{selectedRadioAns}}</b>
                        <b v-if="currentAnswerType == 2" class="text-primary">{{selectedCheckboxAns}}</b>
                        <b v-if="currentAnswerType == 3" class="text-primary">{{selectedButtonAns}}</b>
                        <span
                            v-if="selectedAnswers.length && !selectedAnswers[currentQuestionIndex].selectedAnswer"
                            style="color:red;"
            >you are required to select one</span>-->
            <p>
              <!-- <span>Show question timer here</span> -->
            </p>
            <b-row>
              <b-col class="text-left" cols="5">
                <div class="mt-3">
                  <b-button-group>
                    <b-button variant="outline-danger" v-b-modal.modal-3>{{
                      $t("certifications.cancel")
                    }}</b-button>
                    <b-button
                      variant="outline-primary"
                      :disabled="inTransistion"
                      v-if="currentQuestionIndex != 0"
                      @click="previousQuestion"
                      >{{ $t("certifications.backToQ")}}
                      
                      <!-- {{ currentQuestionIndex }} hide for tecan -->
                      </b-button
                    >
                  </b-button-group>
                </div>
              </b-col>
              <b-col cols="2" :dir="$store.state.rightAlign ? 'rtl' : 'ltr'">
                <span>
                  {{ $t("certifications.viewing") }}
                  <b-badge variant="dark">{{
                    currentQuestionIndex + 1 + "/" + questions.length
                  }}</b-badge>
                </span>
              </b-col>
              <b-col cols="5" class="text-right">
                <div class="mt-3">
                  <b-button-group>
                    <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="nextQuestion"
                      v-if="currentQuestionIndex + 1 != questions.length"
                      >{{ $t("certifications.next") }}</b-button
                    >
                    <b-button
                      v-if="currentQuestionIndex + 1 == questions.length"
                      :disabled="inTransistion"
                      variant="outline-success"
                      @click="
                        isAllowBlankAns
                          ? $bvModal.show('modal-1')
                          : onValidateExam()
                      "
                      >{{ $t("certifications.submitAnswers") }}</b-button
                    >
                    <!-- v-b-modal.modal-1 -->
                  </b-button-group>
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="2">
            <h4>{{ $t("certifications.answerOverview") }}</h4>
            <div style="height: calc(100vh - 110px); overflow:auto;">
              <b-list-group
                v-for="(question, index) in selectedAnswersForExams"
                :key="index"
              >
                <b-list-group-item class="text-left">
                  <b-badge variant="outline-light">Q{{ index + 1 }}</b-badge>
                  <span class="text-danger float-right">
                    <b-badge
                      v-if="currentQuestionIndex >= index || question.viewed"
                      class="mr-2"
                      variant="primary"
                      style="font-size:10px;"
                      >{{ $t("certifications.viewed") }}</b-badge
                    >
                    <b-badge
                      style="font-size:10px;"
                      v-if="question.question && question.question.questionAnswerInputType == 2 && question.answer.length || 
                      question.question && question.question.questionAnswerInputType == 1 && question.answer"
                      variant="dark"
                      >{{ $t("certifications.answered") }}</b-badge>
                      
                    <b-badge style="font-size:10px;" 
                    v-else 
                    variant="danger">{{$t("certifications.notAnswered")}}</b-badge>
                  </span>
                  <span class="text-danger"></span>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-col>
        </b-row>
      </div>

      <div :dir="$store.state.rightAlign ? 'rtl' : 'ltr'" class="my-3" v-else style="height: 85vh;overflow-y: auto;">
        <h1 class="mb-1">{{ formTitle }}</h1>
        <p style="font-size:14px;" v-html="sanitizeHtml(pageIntroText)" class="mb-2"></p>

        <p style="font-size:14px;">
          <strong>{{ $t("certifications.guidance") }}</strong>
        </p>
        <p v-if="examTimeLimit">
          {{ $t("certifications.guidanceText1") }} {{ examTimeLimit }}
          {{ $t("certifications.guidanceText2") }}
        </p>
        <p v-else style="font-size:14px;">
          {{ $t("certifications.guidanceText") }}
        </p>
        <p>
          <strong>{{ $t("certifications.summary") }}</strong>
        </p>
        <p v-if="examTimeLimit > 0">
          {{ $t("certifications.timeLimitText1") }}{{ examTimeLimit }}
          {{ $t("certifications.timeLimitText2") }}
        </p>
        <p style="font-size:14px;" v-if="examAttemptsLimit > 0">
          {{ $t("certifications.summaryText1") }} {{ examAttemptsLimit }}
          {{ $t("certifications.summaryText2") }}
        </p>

        <!-- temp disable for tecan -->
        <!-- <p
          style="font-size:14px;"
          v-if="isExamUnlimitedAttempts == true || examAttemptsLimit > 0"
        >
          {{ $t("certifications.attemptsToDate") }} {{ examAttemptsToDate }}
        </p> -->
        <p style="font-size:14px;" v-if="examAttemptsLimit > 0">
          {{ $t("certifications.remainingAttempts") }}
          {{
            examAttemptsLimit - examAttemptsToDate >= 0
              ? examAttemptsLimit - examAttemptsToDate
              : 0
          }}
        </p>
        <p
          v-if="examAttemptsLimit - examAttemptsToDate <= 0"
          class="text-danger"
        >
          <span v-if="isExamUnlimitedAttempts == !true"
            >{{ $t("certifications.maximumReach") }}
          </span>
        </p>
        <b-button
          v-if="
            isExamUnlimitedAttempts == true ||
              examAttemptsLimit - examAttemptsToDate > 0
          "
          variant="outline-primary"
          class="mr-2"
          @click="startExamImmediately"
          >{{ $t("certifications.startNow") }}</b-button
        >
        <!-- removing modal, exam starts on one click
        v-b-modal.modal-2
        @click="onTimerSet(true)" -->
        <!-- to="/my-certifications" -->

        <b-button
          @click="onBack"
          v-if="
            isExamUnlimitedAttempts == true ||
              examAttemptsLimit - examAttemptsToDate > 0
          "
          >{{ $t("certifications.doLate") }}</b-button
        >
        <b-button @click="onBack" v-else>{{
          $t("certifications.goBack")
        }}</b-button>
      </div>
    </b-container>

    <b-modal
      id="modal-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('certifications.startExam')"
    >
      <p class="my-4">
        {{ $t("certifications.examAboutToStartText1") }} {{ countDown }}
        {{ $t("certifications.examAboutToStartText2") }}
      </p>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="startExamImmediately">{{
          $t("certifications.startImmediately")
        }}</b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          @click="onTimerSet(false)"
          >{{ $t("certifications.cancel") }}</b-button
        >
      </template>
    </b-modal>

    <!-- simple review no need for this in rms -->
     <!-- <b-modal
      id="modal-1"
      modal-header-close="No"
      :ok-title="$t('certifications.submit')"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      :title="$t('certifications.submitExam')"
      :cancel-title="$t('certifications.cancel')"
      @ok="submitAnswers"
    >
      <p>{{ $t("certifications.aboutToSubmitTextSimple") }}</p>
    </b-modal> -->

    <!-- review modal with answers -->
    <b-modal
      id="modal-1"
      modal-header-close="No"
      :ok-title="$t('certifications.submit')"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      :title="$t('certifications.submitExam')"
      :cancel-title="$t('certifications.cancel')"
      @ok="submitAnswers"
    >
      <p>{{ $t("certifications.aboutToSubmitText") }}</p>
      <p>
        <strong>{{ $t("certifications.note") }}</strong>
        {{ $t("certifications.noteText") }}
      </p>
      <ul v-for="(ans, index) in this.selectedAnswersForExams" :key="index">
        <!-- for checkbox types -->
        <li v-if="ans.answer && ans.question.questionAnswerInputType == 2">
          {{ $t("certifications.question") }} {{ index + 1 }}:
          <ul v-for="(ansMulti, indexMulti) in ans.answer" :key="indexMulti">
            <li>
              {{
                ansMulti[selectedLanguage] || $t("certifications.noAnsGiven")
              }}
            </li>
          </ul>
        </li>
        <!-- for type radio -->
        <li v-if="ans.answer && ans.question.questionAnswerInputType == 1">
          {{ $t("certifications.question") }} {{ index + 1 }}:
          {{ ans.answer[selectedLanguage] || $t("certifications.noAnsGiven") }}
        </li>
      </ul>
    </b-modal>

    <b-modal
      id="modal-3"
      :title="$t('certifications.cancelExam')"
      :ok-title="$t('certifications.ok')"
      :cancel-title="$t('certifications.cancel')"
      @ok="onCancelExam"
    >
      <p class="my-4">
        {{ $t("certifications.cancelExamText1") }}
        <span v-if="isExamUnlimitedAttempts == !true">
          {{ $t("certifications.cancelExamText2") }}
          {{ $t("certifications.cancelExamText3") }}
          {{ examAttemptsLimit - examAttemptsToDate }}
          {{ $t("certifications.cancelExamText4") }}
        </span>
      </p>
    </b-modal>

    <!-- modal will show all submited answers -->
    <b-modal
      id="modal-submitted"
      no-close-on-esc
      no-close-on-backdrop
      no-enforce-focus
      hide-header-close
      scrollable
      ok-only
      size="xl"
      :ok-title="$t('certifications.closeText')"
      :title="$t('certifications.examSubmittedText')"
      :cancel-title="$t('certifications.cancel')"
      @hidden="onBack"
    >
      <!-- @hidden="$router.push('/my-certifications')" -->

      <p>{{ $t("certifications.thankYouText") }}</p>
      <p class="text-center">
        <strong>{{ $t("certifications.examResult") }}</strong>
      </p>
      <p>
        {{ $t("certifications.score") }} {{ currentScore }}
        {{ $t("certifications.outOf") }} {{ totalQuestionScore }}
      </p>
      <p>{{ $t("certifications.yourResult") }} {{ examResult }}%</p>
      <p>{{ $t("certifications.toPassExam") }} {{ scoreToPass }}%</p>
      <p v-if="isPassExam">
        {{ $t("certifications.examStatus") }}
        <b-badge variant="success">{{ $t("certifications.pass") }}</b-badge>
      </p>
      <p v-else>
        {{ $t("certifications.examStatus") }}
        <b-badge variant="danger">{{ $t("certifications.fail") }}</b-badge>
      </p>
      <p class="text-center" v-if="isPassExam">
        <strong>{{ $t("certifications.congrats") }}</strong>
      </p>
      <p class="text-center" v-else>
        <strong>{{ $t("certifications.PlsTryAgain") }}</strong>
      </p>
    </b-modal>

    <!-- invalid modal show -->
    <b-modal
      header-bg-variant="danger"
      id="modal-invalid"
      :title="$t('certifications.alert')"
      :ok-title="$t('certifications.goToQuestion')"
      :cancel-title="$t('certifications.cancel')"
      @ok="onNavigateToInvalidQuestion"
    >
      <p class="text-danger">{{ $t("certifications.blankAns") }}</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SectionUserContainer from "../containers/SectionUserContainer";
import AppLoader from "../components/Loader/Loader";
import CountDownTimer from "../components/countdowntimer";
import iconColorMixin from "../mixins/iconColorMixin";
import moment from "moment";
import _ from "lodash";
import { EventBus } from "@/event-bus.js";

import { Helper } from "../helpers";

import { HTTP } from "../utils/HTTP";
import Logo from "../components/logo/logo.vue";

export default {
  name: "UserExamPage",
  mixins: [iconColorMixin],
  components: {
    SectionUserContainer,
    AppLoader,
    CountDownTimer,
    Logo,
  },
  data() {
    return {
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      inTransistion: false, // set to true when user selects answer and auto navigates to next question, used to hide or disable buttons
      pageIntroText: null,
      formTitle: {},
      startExam: false,
      currentQuestionIndex: 0,
      currentQuestion: null,
      currentAnswers: null,
      currentAnswerType: 1,
      currentExamAttempt: 0,
      enabled: true,
      dragging: false,
      countDown: 10,
      stopTimer: false,
      selected: "english",
      isInvalid: false,
      examTimeLimit: 0,
      examAttemptsToDate: 0,
      examAttemptsLimit: 0,
      isExamUnlimitedAttempts: false,
      selectedAnswers: [],
      questions: [],
      visitedQuestions: [],
      visitedQuestionsAndAnswered: [],
      fromButton: false,
      bgColor: process.env.VUE_APP_ICON_COLOR,

      // stepper functionility
      noOfSteps: 0,
      selectedRadioAns: "",
      selectedCheckboxAns: [],
      selectedButtonAns: "",
      currentScore: 0,
      totalQuestionScore: 0,
      scoreToPass: 0,
      examResult: 0,
      isPassExam: false,

      // exam timer
      examPresentTime: null,
      showTimer: false,
      isAllowBlankAns: false,

      invalidQuestionIndex: null,
      isAllCorrectMandatory: false
    };
  },
  mounted() {
    this.setLanguagesToStore();
    let form = JSON.parse(localStorage.getItem("activeFormSchema"));
    this.formTitle = form.formTitle[this.selectedLanguage];
    this.formDescription = form.formDescription[this.selectedLanguage];
    this.pageIntroText = form.formIntroText[this.selectedLanguage];
    this.examTimeLimit = form.formConfiguration.exam.examTimeLimit;
    this.scoreToPass = form.formConfiguration.exam.examPassMark;
    this.examAttemptsLimit = form.formConfiguration.exam.examMaxAttempts;
    this.isAllCorrectMandatory = form.formConfiguration.exam.isAllCorrectMandatory || false;
    this.isExamUnlimitedAttempts =
      form.formConfiguration.exam.isUnlimitedAttempts;
    this.isAllowBlankAns = form.formConfiguration.exam.isAllowedEmpty || false;

    if (
      form.formConfiguration.exam.examUniqueAnswersPerAttempt &&
      form.formConfiguration.exam.examUniqueAnswersPerAttempt > 0
    ) {
      this.questions = this.getRandom(
        form.formSection[0].formElements,
        form.formConfiguration.exam.examUniqueAnswersPerAttempt
      );
    } else {
      this.questions = form.formSection[0].formElements;
    }
    this.currentQuestion = this.questions[
      this.currentQuestionIndex
    ].questionText[this.selectedLanguage];
    // if(form.formConfiguration.exam.examSequentialAnswer == 1)
    // {
    // 	this.currentAnswers = this.shuffleArray(this.questions[this.currentQuestionIndex].answers);
    // }
    // else{
    // 	this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
    // }
    this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
    this.currentAnswerType = this.questions[
      this.currentQuestionIndex
    ].questionAnswerInputType;
    this.noOfSteps = this.questions.length;
    this.examPresentTime = this.examTimeLimit + ":" + 0;

    this.setSelectedAnswers();
    this.examAttemptsToDate = parseInt(
      localStorage.getItem("examAttemptsToDate")
    );
    // console.log("form", form.formConfiguration.exam)
  },
  beforeDestroy() {
    this.examPresentTime = null;
    this.showTimer = false;
    this.onResetLocalData();
  },

  created() {
    // window.open ("user-exam","mywindow","status=1,toolbar=0");
    window.stop();
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    }),
    ...mapState(["selectedAnswersForExams"]),

    customTriangle() {
      return {
        "--user-font": this.bgColor,
      };
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.fromButton) {
      next();
    } else {
      if(to.path == '/profile'){
        next();
      }
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  },

  methods: {
    sanitizeHtml,
    ...mapActions(["setLanguage"]),

    setLanguagesToStore() {
      let languageInLocalStore =
        localStorage.getItem("formDefaultLanguage") || "english";
      if (languageInLocalStore == "chinese simplified") {
        this.$i18n.locale = "chinese";
      } else if (languageInLocalStore == "chinese traditional taiwan") {
        this.$i18n.locale = "chinesetr";
      } else if (languageInLocalStore == "chinese traditional hong kong") {
        this.$i18n.locale = "chinese";
      } else if (languageInLocalStore == "portuguese brazilian") {
        this.$i18n.locale = "portuguesebr";
      } else if (languageInLocalStore == "bahasa indonesian") {
        this.$i18n.locale = "indonesian";
      } else {
        this.$i18n.locale = languageInLocalStore;
      }
      this.$store.state.form1.formDefaultLanguage = languageInLocalStore;
      this.$store.state.selectedLanguage = languageInLocalStore == 'bahasa indonesian' ? 'indonesian' : languageInLocalStore;
    },

    onResetLocalData() {
      localStorage.removeItem("taskId");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("activeTaskStatus");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("examAttemptsToDate");
      localStorage.removeItem("examAttemptId");
      localStorage.removeItem("tempForm");
    },

    startExamTimer() {
      let presentTime = this.examPresentTime;
      // let presentTime = 10 + ":" + 10;
      let timeArray = presentTime.split(/[:]+/);
      let m = timeArray[0];
      let s = this.checkSecond(timeArray[1] - 1);
      if (s == 59) {
        m = m - 1;
      }

      if (m < 0) {
        // alert('timer completed')
        this.submitAnswers();
        this.examPresentTime = null;
        this.showTimer = false;
      } else {
        this.examPresentTime = m + ":" + s;
        setTimeout(this.startExamTimer, 1000);
      }
    },

    checkSecond(sec) {
      if (sec < 10 && sec >= 0) {
        sec = "0" + sec;
      } // add zero in front of numbers < 10
      if (sec < 0) {
        sec = "59";
      }
      return sec;
    },

    getRandom(arr, n) {
      var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
      if (n > len)
        throw new RangeError("getRandom: more elements taken than available");
      while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm.
     */
    shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    setSelectedAnswers() {
      this.$store.state.selectedAnswersForExams = [];
      let allQuestions = _.cloneDeep(this.questions);
      for (let i = 0; i < allQuestions.length; i++) {
        this.selectedAnswersForExams.push({
          questionIndex: null,
          answer: null,
          answerIndex: null,
          viewed: false,
          question: null,
        });
      }
    },

    autoNextQuestion() {
      return false;
      this.inTransistion = true;
      setTimeout(() => {
        this.nextQuestion();
        this.inTransistion = false;
      }, 1000);
    },

    startExamImmediately() {
      this.startExam = true;
      if (this.examTimeLimit && this.examTimeLimit > 0) {
        this.showTimer = true;
        setTimeout(this.startExamTimer, 2000);
      }

      this.$bvModal.hide("modal-2");
      this.updateAttempt();
    },

    async updateAttempt() {
      let taskId = localStorage.getItem("taskId");

      /**
       * to logic here to select random questions
       */

      const URI = "v1/mytpp/task/exam/attempt",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        };
      const Result = HTTP(
        "post",
        URI,
        { taskId: taskId, taskStatus: 1 },
        headers,
        null,
        true
      );
      return Result.then((response) => {
        this.examAttemptsToDate++;

        localStorage.setItem(
          "examAttemptsToDate",
          parseInt(this.examAttemptsToDate)
        );
        localStorage.setItem(
          "examAttemptId",
          parseInt(response.data.attemptId)
        );
      }).catch((err) => {});
    },

    onTimerSet(value) {
      if (value) {
        this.stopTimer = false;
        this.examStartCountDownTimer();
      } else {
        this.stopTimer = true;
        this.countDown = 10;
        this.$bvModal.hide("modal-2");
      }
    },

    examStartCountDownTimer() {
      if (this.countDown > 0 && !this.stopTimer) {
        setTimeout(() => {
          this.countDown -= 1;
          this.examStartCountDownTimer();
        }, 1000);
      }

      if (this.countDown == 0) {
        if (!this.startExam) {
          this.startExam = true;
          this.updateAttempt();

          this.$bvModal.hide("modal-2");
        }
      }
    },

    timer() {
      // get the number of seconds that have elapsed since
      // startTimer() was called
      diff = duration - (((Date.now() - start) / 1000) | 0);

      // does the same job as parseInt truncates the float
      minutes = (diff / 60) | 0;
      seconds = diff % 60 | 0;

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.textContent = minutes + ":" + seconds;

      if (diff <= 0) {
        // add one second so that the count down starts at the full duration
        // example 05:00 not 04:59
        start = Date.now() + 1000;
      }
    },

    startTimer(duration, display) {
      var start = Date.now(),
        diff,
        minutes,
        seconds;

      // we don't want to wait a full second before the timer starts
      timer();
      setInterval(timer, 1000);
    },

    setAnswer(answer, answerIndex, type) {
      // alert("setAnswer event fire", actualAns)
      let index = this.currentQuestionIndex;
      // let deep = _.cloneDeep(this.selectedAnswersForExams)
      if (type === "radio") {
        this.selectedRadioAns = answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      if (type === "checkbox") {
        // this.selectedCheckboxAns = answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = this.selectedCheckboxAns;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      if (type === "button") {
        this.selectedButtonAns = answer.answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer.answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
        // this.setScoreToAnswer();
      }
      this.selectedAnswersForExams[index].viewed = true;
    },

    nextQuestion() {
      if (this.currentQuestionIndex + 1 < this.questions.length) {
        this.currentQuestionIndex++;
        this.currentQuestion = this.questions[ this.currentQuestionIndex].questionText[this.selectedLanguage];
        this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
        this.currentAnswerType = this.questions[this.currentQuestionIndex].questionAnswerInputType;

        this.selectedRadioAns = this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
        this.selectedCheckboxAns = this.selectedAnswersForExams[this.currentQuestionIndex].answer || [];
        this.selectedButtonAns = this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";

      }
    },

    previousQuestion() {
      // console.log("currentQuestionIndex", this.currentQuestionIndex)
      this.currentQuestionIndex--;
      this.setAnswer();
      this.currentQuestion = this.questions[
        this.currentQuestionIndex
      ].questionText[this.selectedLanguage];
      this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
      this.currentAnswerType = this.questions[
        this.currentQuestionIndex
      ].questionAnswerInputType;
      this.selectedRadioAns =
        this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
      this.selectedCheckboxAns = this.selectedAnswersForExams[this.currentQuestionIndex].answer || [];
      this.selectedButtonAns =
        this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
    },

    onBack() {
      this.fromButton = true;
      this.$router.push("/my-certifications");
    },

    onValidateExam() {
      let isValid = false;
      outerLoop: for (let i = 0; i < this.selectedAnswersForExams.length; i++) {
        if (!this.selectedAnswersForExams[i].answer) {
          this.invalidQuestionIndex = i;
          isValid = false;
          this.$bvModal.show("modal-invalid");
          break outerLoop;
        }
        if (
          this.selectedAnswersForExams[i].question &&
          this.selectedAnswersForExams[i].question.questionAnswerInputType ==
            2 &&
          this.selectedAnswersForExams[i].answer.length < 1
        ) {
          this.invalidQuestionIndex = i;
          isValid = false;
          this.$bvModal.show("modal-invalid");
          break outerLoop;
        }
        isValid = true;
      }

      if (isValid) {
        this.$bvModal.show("modal-1");
      }
    },

    onNavigateToInvalidQuestion() {
      outerLoop: for (let i = 0; i < this.selectedAnswersForExams.length; i++) {
        if (!this.selectedAnswersForExams[i].answer) {
          // this.currentQuestionIndex = this.selectedAnswersForExams.length == this.invalidQuestionIndex+1 ? this.invalidQuestionIndex :  this.invalidQuestionIndex+1
          this.currentQuestionIndex = this.invalidQuestionIndex + 1;
          this.previousQuestion();
          break outerLoop;
        }
        if (
          this.selectedAnswersForExams[i].question &&
          this.selectedAnswersForExams[i].question.questionAnswerInputType ==
            2 &&
          this.selectedAnswersForExams[i].answer.length < 1
        ) {
          this.currentQuestionIndex = this.invalidQuestionIndex + 1;
          this.previousQuestion();
          break outerLoop;
        }
      }
    },

    setScoreToAnswerForAll(){
      this.currentScore = 0;
      this.totalQuestionScore = 0;
      let foundWrong = null;
      let deep = _.cloneDeep(this.selectedAnswersForExams);
      
      deep.map((selectedQ) => {
        let corectedAnsCount = [];
        let selectedCorectedAnsCount = [];
        if (selectedQ.question && selectedQ.question.answers.length && selectedQ.question.questionAnswerInputType == 2) {
          
          // for all corrected answer must be selected // multi ans nust me selected
              for(let aa of selectedQ.question.answers){
                  if(aa.isCorrectAnswer == "Yes"){
                  corectedAnsCount.push(aa.answer)
                }
               }
              for (let q of selectedQ.answer) {
              let foundYesAns = selectedQ.question.answers.find((item) => item.answer == q && item.isCorrectAnswer == "Yes")
                if(foundYesAns){
                  selectedCorectedAnsCount.push(q)
                }
              }


              for (let q of selectedQ.answer) {
                 foundWrong = selectedQ.question.answers.find((item) => item.answer == q && item.isCorrectAnswer == "No");
                  if (foundWrong){
                    return;
                  }else if(corectedAnsCount.length !== selectedCorectedAnsCount.length){
                    foundWrong = null; 
                    return;
                  }
              }
              
              if (!foundWrong) {
               this.currentScore = parseInt(this.currentScore) + parseInt(selectedQ.question.questionScore);
            }          
        }
        if (
          selectedQ.question &&
          selectedQ.question.answers.length &&
          selectedQ.question.questionAnswerInputType == 1
        ) {
          selectedQ.question.answers.map((ans) => {
            if (
              selectedQ.answer === ans.answer &&
              ans.isCorrectAnswer === "Yes"
            ) {
              // console.log("ans radios", ans);

              this.currentScore =
                parseInt(this.currentScore) +
                parseInt(selectedQ.question.questionScore);
            }
          });
        }
      });

    },

    setScoreToAnswer() {
      this.currentScore = 0;
      this.totalQuestionScore = 0;
      let foundWrong = null;
      let deep = _.cloneDeep(this.selectedAnswersForExams);
      
      deep.map((selectedQ) => {
        if (selectedQ.question && selectedQ.question.answers.length && selectedQ.question.questionAnswerInputType == 2) {
          for (let q of selectedQ.answer) {
            foundWrong = selectedQ.question.answers.find((item) => item.answer == q && item.isCorrectAnswer == "No");
            if (foundWrong) return;
          }
          if (!foundWrong) {
            this.currentScore = parseInt(this.currentScore) + parseInt(selectedQ.question.questionScore);
          }
          
        }
        if (
          selectedQ.question &&
          selectedQ.question.answers.length &&
          selectedQ.question.questionAnswerInputType == 1
        ) {
          selectedQ.question.answers.map((ans) => {
            if (
              selectedQ.answer === ans.answer &&
              ans.isCorrectAnswer === "Yes"
            ) {
              // console.log("ans radios", ans);

              this.currentScore =
                parseInt(this.currentScore) +
                parseInt(selectedQ.question.questionScore);
            }
          });
        }
      });
    },

    calculateScore() {
      
      if(this.isAllCorrectMandatory){
      this.setScoreToAnswerForAll();
      }else{
      this.setScoreToAnswer();
      }
      this.questions.map((score) => {
        this.totalQuestionScore =
          this.totalQuestionScore + parseInt(score.questionScore);
      });

      let totalScore = this.totalQuestionScore,
        obtainScore = this.currentScore,
        scoreToPass = this.scoreToPass;

      // console.log("obtainScore", obtainScore);
      // console.log("scoreToPass", totalScore);

      let result = (obtainScore / totalScore) * 100;
      this.examResult = Math.round(result);
      // console.log("---this.examResult---", this.examResult);

      this.isPassExam = this.examResult >= scoreToPass ? true : false;
    },

    submitAnswers(e) {
      let taskId = localStorage.getItem("taskId");
      let attemptId = localStorage.getItem("examAttemptId");
      let userId = localStorage.getItem("userId");

      this.calculateScore();
      let examResult = {
        obtainScore: this.currentScore,
        scoreToPass: this.scoreToPass,
        totalQuestionScore: this.totalQuestionScore,
        obtainResultAsPercentage: this.examResult,
        examStatus: e == "only" ? false : this.isPassExam,
        isCancelledExam: e == "only",
        userId: userId,
        examAttemptsLimit: this.examAttemptsLimit,
        attmptsRemaining: this.examAttemptsToDate,
        isUnlimitedAttempts: this.isExamUnlimitedAttempts,
      };

      const URI = "v1/mytpp/task/submitexam",
        headers = {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        };
      const Result = HTTP(
        "post",
        URI,
        {
          answers: this.selectedAnswersForExams,
          examResult,
          id: taskId,
          attemptId: attemptId,
        },
        headers,
        null,
        true
      );
      return Result.then((response) => {
        if (e == "only") {
          this.fromButton = true;
          this.$router.push("/my-certifications");
        } else {
          this.fromButton = true;
          this.$bvModal.show("modal-submitted");
        }
      }).catch((err) => {});
    },

    onCancelExam() {
      this.submitAnswers("only");
      // $router.push('/my-certifications')
    },
  },
};
</script>

<style>
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 290px);
  /* height:400px */
}

.selectPicket {
  width: 350px;
}
.animate-slide-from-left {
  position: relative;
  animation: fromLeft 2s;
  opacity: 1;
}
.animate-slide-to-right {
  position: relative;
  animation: toRight 1s;
  opacity: 1;
}
@keyframes fromLeft {
  from {
    left: -5px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes toRight {
  from {
    left: 0;
    opacity: 1;
  }
  to {
    left: 150px;
    opacity: 0;
  }
}

.first {
  width: 20rem;
  height: 40px;
  /* background: #33dd97; */
  position: absolute;
}

#talkbubble {
  margin-top: 45px;
  width: 20rem;
  height: 12rem;
  /* background: var(--]); */
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

#talkbubble:before {
  content: "";
  position: absolute;
  right: 9rem;
  top: 12rem;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  /* border-top: 25px solid #33dd97; */
  border-top: 25px solid var(--user-font);
  border-left: 12px solid transparent;
}
.v-html img {
  max-width: 500px !important;
}
</style>
